export class ValueAdditionIdRequest {
    valueAdditionId: number;
}